import {
  CHAT_CARD_WIDTH_VAR,
  EXPANDED_WIDTH_RATIO,
  EXPANDED_WIDTH_VAR,
} from "constants/chatBubbleWidths";
import { RefObject, useEffect, useRef } from "react";

export const useExpandedMessageWidth = <T extends HTMLElement>(
  isEnabled: boolean
): RefObject<T | null> => {
  const paneRef = useRef<T>(null);

  useEffect(() => {
    const pane = paneRef.current;
    if (!pane || !isEnabled) return undefined;

    const observer = new ResizeObserver(([entry]) => {
      const width = Math.round(entry.contentRect.width * EXPANDED_WIDTH_RATIO);
      pane.style.setProperty(EXPANDED_WIDTH_VAR, `${width}px`);
      pane.style.setProperty(CHAT_CARD_WIDTH_VAR, `${width}px`);
    });

    observer.observe(pane);

    return () => {
      observer.disconnect();
      pane.style.removeProperty(EXPANDED_WIDTH_VAR);
      pane.style.removeProperty(CHAT_CARD_WIDTH_VAR);
    };
  }, [isEnabled]);

  return paneRef;
};
